import { Resolver, gql } from '@apollo/client';

import axios, { AxiosResponse } from 'axios';

interface AddInvitationInput {
    token: string;
    collaborations: string[];
    inviteeEmail: string;
    invitationsUrl: string;
    inviteeFirstName: string;
    inviteeLastName: string;
    inviteSenderId: string;
    inviteSenderName: string;
}

interface AddInvitationResult {
    args: AddInvitationInput;
    response: AxiosResponse<InvitationResult>;
}

export const addInvitation: Resolver = async (
    obj: Record<string, unknown>,
    args: AddInvitationInput,
): Promise<AddInvitationResult | WrappedError> => {
    const {
        token,
        collaborations,
        inviteeEmail,
        invitationsUrl,
        inviteeFirstName,
        inviteeLastName,
        inviteSenderId,
        inviteSenderName,
    } = args;

    try {
        const response = await axios({
            method: 'post',
            url: invitationsUrl,
            data: {
                collaborations,
                invitee: {
                    email: inviteeEmail.toLowerCase(),
                    first_name: inviteeFirstName,
                    last_name: inviteeLastName,
                },
                inviteSender: {
                    id: inviteSenderId,
                    // We don't need to send a separate first/last name here (yet). The TrqkUser
                    // uses a single `name` field to match the Cognito user schema; this won't
                    // change unless there is a strong need for it.
                    name: inviteSenderName,
                },
            },
            headers: {
                Authorization: token,
            },
        });

        return {
            args,
            response,
        };
    } catch (err) {
        return { error: err };
    }
};

export const ADD_INVITATION = gql`
    mutation AddInvitation(
        $token: String
        $collaborations: [String]
        $inviteeEmail: String
        $invitationsUrl: String
        $inviteeFirstName: String
        $inviteeLastName: String
        $inviteSenderId: String
        $inviteSenderName: String
    ) {
        addInvitation(
            token: $token
            collaborations: $collaborations
            invitationsUrl: $invitationsUrl
            inviteeEmail: $inviteeEmail
            inviteeFirstName: $inviteeFirstName
            inviteeLastName: $inviteeLastName
            inviteSenderId: $inviteSenderId
            inviteSenderName: $inviteSenderName
        ) @client
    }
`;
